<template>
    <v-container grid-list-xl>
        <v-layout wrap justify-space-between>
            <v-flex xs12 md12>
                <h1>Check SMS sent to: <br />{{ cc }} {{ phone }}</h1>
            </v-flex>
            <v-flex xs12 md12>
                Your confirmation code will come from [TapTags]
                <br />인증번호는 [TapTags]을 통해서 발송됩니다.
                <br />
            </v-flex>

            <v-form
                ref="confirm_form"
                style="width: 100%"
                @submit.prevent="confirm"
            >
                <v-layout wrap justify-space-between>
                    <v-flex xs12 md12>
                        <v-text-field
                            v-model="confirmation"
                            :counter="6"
                            :rules="[rules.confirmation_numbers]"
                            :error-messages="confirmation_error_messages"
                            label="인증번호 6자리를 입력하세요.  Confirmation #"
                            type="number"
                            pattern="\d*"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout wrap justify-space-between>
                    <v-flex xs12 md12>
                        <v-btn color="primary" @click="confirm"> Confirm</v-btn>
                    </v-flex>
                </v-layout>
            </v-form>

            <v-flex xs12 md12>
                <v-btn @click="uncheck"
                    >전화번호 수정하기 / Change Phone Number</v-btn
                >
            </v-flex>
        </v-layout>
        <br />
        <h2 class="headline font-weight-bold mb-3">Need Help?</h2>
        Having trouble or need help? Email 주소 daltotheworld@gmail.com
    </v-container>
</template>

<script>
import {
    phone_countries,
    country_abbreviation_to_country_code,
} from "@/settings";
export default {
    props: ["auth"],
    data: () => ({
        success: false,
        cc: "",
        phone: "10",
        phone_validated: false,
        phone_error_messages: [],
        confirmation: "",
        confirmation_disabled: true,
        confirmation_error_messages: [],
        valid: false,
        countries: phone_countries,
        ask_password: true,
        password: undefined,
        password_again: undefined,
        password_error_messages: [],
        new_password: "", // when auto generated for display
        engine: "",
        rules: {
            required: (value) => !!value || "Required.",
            counter: (value) => value.length <= 20 || "Max 20 characters",
            confirmation_numbers: (value) => {
                const pattern = /^\d{6}$/;
                return pattern.test(value) || "Should only 6 digits";
            },
            phone: (value) => {
                const pattern = /^\d+$/;
                return pattern.test(value) || "Invalid phone number";
            },
            email: (value) => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Invalid e-mail.";
            },
            passwordRules: [
                (value) => !!value || "Please type password.",
                (value) =>
                    (value && value.length >= 6) || "minimum 6 characters",
            ],
        },
    }),
    beforeMount: async function() {
        if (this.$route.params.save_phone) {
            this.$data.phone = this.$route.params.save_phone;
            this.phone_validated = true;
        }
        if (this.$route.params.save_cc) {
            this.$data.cc = this.$route.params.save_cc;
        } else {
            var res = await this.auth.guess_country();
            console.log(
                "country_abbreviation_to_country_code",
                country_abbreviation_to_country_code
            );
            this.$data.cc =
                country_abbreviation_to_country_code[res.data.country];
        }
    },
    watch: {
        phone(to) {
            if (to?.startsWith("0")) {
                this.$data.phone = to.replace(/^0/, "");
            }
        },
        cc(to, from) {
            if (to != "+82" && this.$data.phone == "10") {
                this.$data.phone = "";
            }
            if (to == "+82" && !this.$data.phone) {
                this.$data.phone = "10";
            }
        },
    },
    computed: {},
    methods: {
        stopsafari: function() {
            console.log("no auto-submit")
            return false;
        },
        confirmPasswordRules: function() {
            /*
        if (this.password.length < 6) {
            //this.password_error_messages = ["Password too short"]
            return "Password too short";
        }
        */
            if (this.password != this.password_again) {
                //this.password_error_messages = ["Password does not match"]
                return "Password does not match";
            }
            this.password_error_messages = [];
            return true;
        },
        uncheck() {
            this.$router.push({
                name: "recover_phone",
            });
        },
        confirm: async function() {
            if (!this.$refs.confirm_form.validate()) {
                this.confirmation_error_messages = "Incorrect Number";
                return false;
            }

            var res = await this.auth.recover_phone_verify(
                this.cc,
                this.phone,
                this.confirmation
            );
            console.log("verify result", res);

            if (!res.data.success) {
                this.confirmation_error_messages = res.data.message;
                console.log(
                    "fail confirmation",
                    this.confirmation_error_messages,
                    res.data.message
                );
            } else {
                this.valid = true;
                localStorage.setItem("last_cc", this.$data.cc);
                localStorage.setItem("last_phone", this.$data.phone);

                // Custom message when new password must be directly shown
                this.$router.push({
                    name: "recover_phone_success",
                });

                return;
            }
        },
    },
};
</script>
<style scoped>
.formlabel {
    height: auto;
    padding: 0 10px;
}
.formlabeless .v-input {
    padding-top: 0px;
}
</style>
